import { useEffect } from 'react';


interface Options {
    callback: () => void;
    offset?: number;
    enabled?: boolean;
}

export function useScrollToBottomCallback({
    callback,
    offset = 200,
    enabled = true,
}: Options) {
    useEffect(() => {
        if (!enabled) return;

        const checkIfNearBottom = () => {
            const nearBottom = window.innerHeight + window.scrollY >= document.body.offsetHeight - offset;
            if (nearBottom) callback();
        };

        checkIfNearBottom();
        window.addEventListener('scroll', checkIfNearBottom);
        return () => window.removeEventListener('scroll', checkIfNearBottom);
    }, [callback, offset, enabled]);
}
